import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200 pt-14 md:pt-20 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50 tracking-tight">
                LitBuy <span className="text-primary-400">Spreadsheets</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
              Your trusted resource hub for LitBuy spreadsheet guides, 
              product categories, and safe shopping tips.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/article/what-is-litbuy-spreadsheet" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Guides
              </Link>
              <a href="/#safety" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Safety
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Main Store
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              Popular Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              Legal
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="/#safety" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Disclaimer
              </a>
              <a href="/#safety" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="/#safety" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Safety Notice
              </a>
              <a href="/#safety" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                Terms of Use
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} LitBuy Spreadsheets. All rights reserved. 
            This is an independent informational resource — we are not affiliated with any specific platform.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 hover:bg-background-700/50 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm text-background-400"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 hover:bg-background-700/50 transition-colors cursor-pointer">
              <i className="ri-youtube-line text-sm text-background-400"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/50 hover:bg-background-700/50 transition-colors cursor-pointer">
              <i className="ri-facebook-line text-sm text-background-400"></i>
            </a>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="font-heading text-4xl md:text-6xl font-bold text-background-700/20 select-none">
            LitBuy Spreadsheets
          </p>
        </div>
      </div>
    </footer>
  );
}